module.exports = " <v-table [tableColumns]=tableColumns [tableRows]=tableRows [loading]=loading [clickable]=false></v-table> ";